export default {
  "content": "<g class=\"bv-icon-category\"><path fill=\"var(--bv-color-purple-4)\" d=\"M247.4 14.57L131.8 210.19a10 10 0 008.6 15.09h231.2a10 10 0 008.6-15.09L264.6 14.57a10 10 0 00-17.2 0z\"/><circle fill=\"var(--bv-color-teal-4)\" cx=\"399.36\" cy=\"399.36\" r=\"112.64\"/><path fill=\"var(--bv-color-indigo-4)\" d=\"M10 286.72h184.8a10 10 0 0110 10v184.8a10 10 0 01-10 10H10a10 10 0 01-10-10v-184.8a10 10 0 0110-10z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 512 512"
  }
};